module.exports = __webpack_public_path__ + "media/images/arrow-down-black-3351dc5715a0cc04eed1fd6bde88dbfd.svg";